import { lazyWithPrefetch } from "@/lib/route-loader";

/**
 * Registre central des routes — Open/Closed:
 *  ajouter une route = une seule entrée ici, le reste suit.
 */
export const Home = lazyWithPrefetch(() => import("@/pages/Index"));
export const About = lazyWithPrefetch(() => import("@/pages/About"));
export const Services = lazyWithPrefetch(() => import("@/pages/Services"));
export const Realisations = lazyWithPrefetch(() => import("@/pages/Realisations"));
export const Contact = lazyWithPrefetch(() => import("@/pages/Contact"));
export const MentionsLegales = lazyWithPrefetch(() => import("@/pages/MentionsLegales"));
export const Confidentialite = lazyWithPrefetch(() => import("@/pages/Confidentialite"));
export const NotFound = lazyWithPrefetch(() => import("@/pages/NotFound"));

/** Map path -> preload(): consommée par les Link/NavLink pour amorcer la navigation. */
export const ROUTE_PRELOADERS: Record<string, () => Promise<unknown>> = {
  "/": Home.preload,
  "/a-propos": About.preload,
  "/services": Services.preload,
  "/realisations": Realisations.preload,
  "/contact": Contact.preload,
  "/mentions-legales": MentionsLegales.preload,
  "/politique-confidentialite": Confidentialite.preload,
};

export const preloadRoute = (path: string): void => {
  ROUTE_PRELOADERS[path]?.().catch(() => {
    /* silencieux: c'est juste un préchargement opportuniste */
  });
};
